/**
 * This is not a presentational component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC, ReactNode } from 'react';
import { WiredLogoutBanner } from 'src/services/auth/components/LogoutBanner';
import { useSessionWatcherState } from './useSessionWatcherState';

const MAC_LOGOUT_BANNER_STORAGE_KEY = 'zhl.mortgageapplicationcenter.auth.banner';

export const SessionWatcher: FC<{ children: ReactNode }> = ({ children }) => {
    const { onSignInClick } = useSessionWatcherState();

    return (
        <>
            {/* Disabled until true logout is supported */}
            {/* <WiredSessionNearingExpiry onLogoutHook={onLogout} /> */}
            <WiredLogoutBanner storageKey={MAC_LOGOUT_BANNER_STORAGE_KEY} onSignInClick={onSignInClick} />
            {children}
        </>
    );
};
